import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const Button = styled(Link).withConfig({
  shouldForwardProp: (prop) =>
    !['primary', 'dark', 'big', 'fontBig'].includes(prop),
})`
  border-radius: 50px;
  background: ${({ primary }) => (primary ? '#006ee6' : '#010606')};
  white-space: nowrap;
  padding: ${({ big }) => (big ? '14px 48px' : '12px 30px')};
  color: ${({ dark }) => (dark ? '#010606' : '#ffffff')};
  font-size: ${({ fontBig }) => (fontBig ? '20px' : '16px')};
  outline: none;
  border: none;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: all 0.2s ease-in-out;
  text-decoration: none;
  &:hover {
    background: ${({ primary }) => (primary ? '#ffffff' : '#')};
    color: ${({ dark }) => (dark ? '#ffffff' : '#010606')};
  }
`;